export default __webpack_public_path__ + "static/media/filling_4.cd9d29b7.webp";